export enum UrlList {
  URL = '', // http://localhost:8500

  LOGIN = '/services/beplicsecurity/api/auth/login',
  REFRESH_TOKEN = '/auth/refresh-token',
}
